var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('head-Back',{attrs:{"title":"VIP服务"}}),_vm._v(" "),_c('div',{staticClass:"pay-result"},[_c('div',{class:_vm.imgclass}),_vm._v(" "),_c('p',{staticClass:"pay-result-text"},[_vm._v(_vm._s(_vm.desc))]),_vm._v(" "),_c('button',{on:{"click":_vm.toApp}},[_vm._v("手动跳转")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee47274","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/qml/pay/payResult.vue
// module id = null
// module chunks = 